import { render } from "./RequiHrbp.vue?vue&type=template&id=59393ef8"
import script from "./RequiHrbp.vue?vue&type=script&lang=js"
export * from "./RequiHrbp.vue?vue&type=script&lang=js"

import "./RequiHrbp.vue?vue&type=style&index=0&id=59393ef8&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__